<!-- <app-afairs-tab></app-afairs-tab> -->
<router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
